// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tb-0";